//src/layouts/MainLayout.jsx

import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import AppNavbar from "../components/Navbar";

const SIDEBAR_COLLAPSED_KEY = "wdSidebarCollapsed";
const DESKTOP_MQ = "(min-width: 992px)";

function readCollapsed() {
  try {
    return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "1";
  } catch {
    return false;
  }
}

function MainLayout({ children }) {
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(DESKTOP_MQ).matches : true
  );
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(readCollapsed);

  useEffect(() => {
    const mq = window.matchMedia(DESKTOP_MQ);
    const onChange = () => {
      setIsDesktop(mq.matches);
      if (mq.matches) setMobileOpen(false);
    };
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  useEffect(() => {
    const openMobile = !isDesktop && mobileOpen;
    document.body.classList.toggle("sidebar-open", openMobile);
    return () => document.body.classList.remove("sidebar-open");
  }, [isDesktop, mobileOpen]);

  useEffect(() => {
    try {
      localStorage.setItem(SIDEBAR_COLLAPSED_KEY, collapsed ? "1" : "0");
    } catch {
      /* ignore */
    }
  }, [collapsed]);

  const toggleSidebar = () => {
    if (isDesktop) {
      setCollapsed((v) => !v);
    } else {
      setMobileOpen((v) => !v);
    }
  };

  const closeMobile = () => setMobileOpen(false);

  const handleNavigate = () => {
    if (!isDesktop) closeMobile();
  };

  const sidebarHiddenDesktop = isDesktop && collapsed;
  const menuExpanded = isDesktop ? !collapsed : mobileOpen;

  return (
    <div
      className={`app-shell${sidebarHiddenDesktop ? " sidebar-collapsed" : ""}`}
    >
      <AppNavbar
        onMenuClick={toggleSidebar}
        menuExpanded={menuExpanded}
        isDesktop={isDesktop}
      />

      <div className="app-body">
        <div
          className={`sidebar-overlay${mobileOpen && !isDesktop ? " show" : ""}`}
          onClick={closeMobile}
          aria-hidden={!mobileOpen || isDesktop}
        />

        <Sidebar
          open={mobileOpen}
          collapsed={sidebarHiddenDesktop}
          onNavigate={handleNavigate}
        />

        <main className="main-content">{children}</main>
      </div>
    </div>
  );
}

export default MainLayout;
